import { FormField, Input } from 'src/shared';
import { i18, trb } from '../../../../../Utilities';

export const FieldBankName = () => {
  return (
    <FormField
      name="Payment.BankName"
      label={trb(i18.Labels.BankName)}
    >
      <Input />
    </FormField>
  );
};
